export class AircraftCategory {
  id: number;
  name: string;
}
